module.exports = __webpack_public_path__ + "img/P06-IS2013-2002-058.cb55716d.jpg";